import { useCallback, useSyncExternalStore } from 'react';

/**
 * Whether a media query matches, kept in step as it changes. For layout that has to be decided in
 * markup rather than in CSS — a screen that is tabs on a phone and one long page elsewhere, where
 * the tab roles must only exist when there are tabs. Without `matchMedia` (tests, old engines) it
 * reads as not matching, so those see the wide layout.
 */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      if (typeof window.matchMedia !== 'function') {
        return () => undefined;
      }
      const list = window.matchMedia(query);
      list.addEventListener('change', onChange);
      return () => {
        list.removeEventListener('change', onChange);
      };
    },
    [query],
  );
  return useSyncExternalStore(
    subscribe,
    () => typeof window.matchMedia === 'function' && window.matchMedia(query).matches,
    () => false,
  );
}

/** The app's one phone breakpoint, the same `47.99rem` every stylesheet uses. */
export const PHONE_QUERY = '(max-width: 47.99rem)';
